import { Group, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

/** Consistent page title + subtitle, with an optional right-aligned actions slot. */
export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <Group justify="space-between" align="flex-end" wrap="nowrap" gap="sm">
      <Stack gap={2}>
        <Title order={2}>{title}</Title>
        {subtitle && <Text c="dimmed" size="sm">{subtitle}</Text>}
      </Stack>
      {actions}
    </Group>
  );
}
